export default "__VITE_ASSET__lPaZR9qC__"